import { memo } from "react";

const Skeleton = ({ className = "", cover, style = {} }) => (
    <div className={`skeleton-box ${cover ? "w-100 h-100" : ""} ${className}`} style={style}>
        <span />
    </div>
)

export default memo(Skeleton);